import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';

import MonthPicker from 'components/common-sfims/form/MonthPicker';

/**
 * 대시보드 > 추이 대시보드 - 기간 검색
 */
const RangeMonthPicker = ({ type, value, onUpdate }) => {
  /* variable */
  const format = 'YYYYMM';

  /* state */
  // 시작 월
  const [start, setStart] = useState(
    moment().subtract(1, 'years').format(format)
  );
  // 끝 월
  const [end, setEnd] = useState(moment().format(format));

  /* watch */
  useEffect(() => {
    switch (type) {
      // 원료 가격 추이
      case 0:
        setStart(value.startPriceYm);
        setEnd(value.endPriceYm);

        break;

      // 제품 생산량 추이
      case 1: {
        setStart(value.startProdYm);
        setEnd(value.endProdYm);

        break;
      }

      // 원재료비 추이
      case 2:
        setStart(value.startPriceYm);
        setEnd(value.endPriceYm);

        break;
    }
  }, [type, value]);

  /* event */
  // 월 변경 시
  const onChange = (start, end) => {
    // 제품 생산량 추이
    if (type === 1) {
      onUpdate({
        startProdYm: start,
        endProdYm: end
      });

      return;
    }

    // 원료 가격 / 원재료비 추이
    onUpdate({
      startPriceYm: start,
      endPriceYm: end
    });
  };
  // 시작 월 변경 시
  const onChangeStart = start => {
    setStart(start);
    onChange(start, end);
  };
  // 끝 월 변경 시
  const onChangeEnd = end => {
    setEnd(end);
    onChange(start, end);
  };

  /* view */
  return (
    <>
      <Col sm={2} className="ps-1 pe-1">
        <MonthPicker
          value={start}
          startDate={start}
          endDate={end}
          selectsStart
          onUpdate={onChangeStart}
        />
      </Col>
      <Col sm={2} className="ps-1 pe-1">
        <MonthPicker
          value={end}
          startDate={start}
          endDate={end}
          selectsEnd
          onUpdate={onChangeEnd}
        />
      </Col>
    </>
  );
};

RangeMonthPicker.propTypes = {
  // 구분 (0: 원료 가격 추이, 1: 제품 생산량 추이, 2: 원재료비 추이)
  type: PropTypes.number,

  // 값
  value: PropTypes.object,

  // 값 변경 시 이벤트
  onUpdate: PropTypes.func
};
RangeMonthPicker.defaultProps = {
  type: 0,
  value: {}
};

export default RangeMonthPicker;
